var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-field" }, [
    _c("div", {
      staticClass: "panel-field-opt panel-field-html-help-text",
      domProps: { innerHTML: _vm._s(_vm.field.text) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }